import { useState } from "react";
export const useSubscriptionState = () => {
      const [subscriptionList, setSubscriptionList] = useState([]);
      const [formData, setFormData] = useState({ email: "" });
      const [errors, setErrors] = useState({});
      const [submitting, setSubmitting] = useState(false);
    
      const [notification, setNotification] = useState({
        show: false,
        type: "success",
        title: "",
        message: ""
      });

      return {
        subscriptionList, setSubscriptionList,
        formData, setFormData, errors, setErrors, submitting, setSubmitting, notification, setNotification
      }
}